import { Link } from "react-router-dom";
import styled from "styled-components";
import globalStyles from "../../constants/globalStyles/theme.json";

const { colors, spacing, breakpoints } = globalStyles;

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const DesktopWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  background-color: ${colors.primary.offWhite};
  padding: ${spacing.space24} ${spacing.space24};

  @media (max-width: ${breakpoints.m}) {
    display: none;
  }
`;

export const MobileWrapper = styled.div`
  display: none;
  align-items: center;
  width: 100%;
  background-color: ${colors.primary.offWhite};
  padding-bottom: ${spacing.space4};

  @media (max-width: ${breakpoints.m}) {
    display: flex;
  }
`;

export const MenuButtonContainer = styled.div`
  display: none;
  margin-left: auto;
  margin-right: ${spacing.space24};
  z-index: 999;

  @media (max-width: ${breakpoints.m}) {
    display: block;
  }
`;

export const NavLink = styled(Link)`
  text-decoration: none;
  color: ${colors.typography.black};
  margin-right: ${spacing.space32};
  padding: ${spacing.space8} ${spacing.space16};
  font-size: 1.6rem;

  &:last-child {
    margin-right: 0;
  }

  &:hover {
    text-decoration: none;
    background-color: ${colors.primary.green};
    border-radius: 5px;
    color: ${colors.primary.offWhite};
  }

  @media (max-width: ${breakpoints.s}) {
    display: none;
  }
`;

export const NavLinkContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;

  @media (max-width: ${breakpoints.m}) {
    display: none;
  }
`;

export const NavbarLogo = styled.img`
  height: 110px;
  width: 155px;

  @media (max-width: ${breakpoints.m}) {
    margin-top: ${spacing.space12};
    margin-left: ${spacing.space8};
    height: 90px;
    width: 125px;
  }
`;

export const NavbarLogoContainer = styled(Link)`
  display: flex;
  align-items: center;
`;
